import { createFileRoute, redirect } from "@tanstack/react-router";

/** A link to an /agents/nancy page lands on the same page in Nancy's workspace. */
export const Route = createFileRoute("/_authenticated/agents/nancy/$")({
  beforeLoad: ({ location }) => {
    const [first, second] = location.pathname.replace(/^\/agents\/nancy\/?/u, "").split("/");
    const search = location.search;
    if (first === "orders" && second) {
      throw redirect({
        to: "/ws/nancy/orders/$orderId",
        params: { orderId: second },
        search,
        replace: true,
      });
    }
    if (first === "settings") throw redirect({ to: "/ws/nancy/settings", search, replace: true });
    if (first === "graph") {
      throw redirect({
        to: "/ws/nancy/settings",
        search: { ...search, section: "knows" },
        replace: true,
      });
    }
    throw redirect({ to: "/ws/nancy", search, replace: true });
  },
});
